import script from "./SearchUsers.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchUsers.vue?vue&type=script&setup=true&lang=js"

import "./SearchUsers.vue?vue&type=style&index=0&id=193dec03&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-193dec03"]])

export default __exports__